<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="engagePc"
      [label]="'case.fields.engagePc.label' | translate"
      [helpText]="'case.fields.engagePc.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="engagePcDate"
      [label]="'case.fields.engagePcDate.label' | translate"
      [helpText]="'case.fields.engagePcDate.help'"
      [viewMode]="viewMode"
  ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="supplierEngaged"
      [label]="'case.fields.supplierEngaged.label' | translate"
      [helpText]="'case.fields.supplierEngaged.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownSupplierEngagedType,
        entry1: form.get('supplierEngaged')?.value || ''
      }"
      [entry]="'entry1'"
  ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="pcAdditionalInfo"
      [label]="'case.fields.pcAdditionalInfo.label' | translate"
      [helpText]="'case.fields.pcAdditionalInfo.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
    <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="distributedManufacturingPc"
      [label]="'case.fields.distributedManufacturingPc.label' | translate"
      [helpText]="'case.fields.distributedManufacturingPc.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [viewMode]="viewMode"
      [externalSearch]="true"
      [params]="{
        type: dropdownDistributedManufacturingPcType,
        entry1: form.get('distributedManufacturingPc')?.value || ''
      }"
      [entry]="'entry1'"
  ></app-configuration-select-form-field>
  </div>
</div>
